var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c(
        "b-form",
        { attrs: { id: "form-entity", "data-vv-scope": "form-entity" } },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Nombre", "label-for": "#" } },
                  [
                    _c("b-form-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|min:6",
                          expression: "'required|min:6'"
                        }
                      ],
                      staticClass: "w-80",
                      attrs: {
                        placeholder: "ingresa nombre",
                        "data-cy": "name",
                        "data-vv-as": "Nombre",
                        id: "name",
                        name: "name",
                        state: _vm.errors.has("form-entity.name") ? false : null
                      },
                      model: {
                        value: _vm.selectedEntity.name,
                        callback: function($$v) {
                          _vm.$set(_vm.selectedEntity, "name", $$v)
                        },
                        expression: "selectedEntity.name"
                      }
                    }),
                    _c("b-form-invalid-feedback", [
                      _vm._v(
                        " " + _vm._s(_vm.errors.first("form-entity.name")) + " "
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Dirección", "label-for": "#" } },
                  [
                    _c("b-form-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|min:6",
                          expression: "'required|min:6'"
                        }
                      ],
                      attrs: {
                        placeholder: "ingresa dirección",
                        "data-cy": "address",
                        "data-vv-as": "Dirección",
                        id: "address",
                        name: "address",
                        state: _vm.errors.has("form-entity.address")
                          ? false
                          : null
                      },
                      model: {
                        value: _vm.selectedEntity.address,
                        callback: function($$v) {
                          _vm.$set(_vm.selectedEntity, "address", $$v)
                        },
                        expression: "selectedEntity.address"
                      }
                    }),
                    _c("b-form-invalid-feedback", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.errors.first("form-entity.address")) +
                          " "
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Responsable" } },
                  [
                    _vm.entityUsers
                      ? _c("SelectValidate", {
                          attrs: {
                            options: _vm.entityUsers,
                            name: "onCharge",
                            danger: _vm.errors.has("form-entity.onCharge"),
                            "danger-text": _vm.errors.first(
                              "form-entity.onCharge"
                            ),
                            state: _vm.errors.has("form-entity.onCharge")
                              ? false
                              : null,
                            "data-vv-as": "responsable"
                          },
                          model: {
                            value: _vm.selectedEntity.onCharge,
                            callback: function($$v) {
                              _vm.$set(_vm.selectedEntity, "onCharge", $$v)
                            },
                            expression: "selectedEntity.onCharge"
                          }
                        })
                      : _vm._e(),
                    !_vm.entityUsers
                      ? _c("span", [_vm._v(" Entidad no cuenta con usuarios ")])
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Correo Electrónico", "label-for": "#" } },
                  [
                    _c("b-form-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|email",
                          expression: "'required|email'"
                        }
                      ],
                      attrs: {
                        placeholder: "ingresa correo electrónico",
                        "data-cy": "email",
                        "data-vv-as": "Correo",
                        id: "email",
                        name: "email",
                        state: _vm.errors.has("form-entity.email")
                          ? false
                          : null
                      },
                      model: {
                        value: _vm.selectedEntity.email,
                        callback: function($$v) {
                          _vm.$set(_vm.selectedEntity, "email", $$v)
                        },
                        expression: "selectedEntity.email"
                      }
                    }),
                    _c("b-form-invalid-feedback", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.errors.first("form-entity.email")) +
                          " "
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Centro de Costos", "label-for": "#" } },
                  [
                    _vm.costsCenter
                      ? _c("SelectValidate", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            options: _vm.costsCenter,
                            name: "costsCenter",
                            danger: _vm.errors.has("form-entity.costsCenter"),
                            "danger-text": _vm.errors.first(
                              "form-entity.costsCenter"
                            ),
                            state: _vm.errors.has("form-entity.costsCenter")
                              ? false
                              : null,
                            "data-vv-as": "responsable"
                          },
                          model: {
                            value: _vm.selectedEntity.costsCenter,
                            callback: function($$v) {
                              _vm.$set(_vm.selectedEntity, "costsCenter", $$v)
                            },
                            expression: "selectedEntity.costsCenter"
                          }
                        })
                      : _vm._e(),
                    !_vm.costsCenter
                      ? _c("span", [
                          _vm._v(" No se encontraron centro de costos creados ")
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      ),
      _c("vs-divider"),
      _c(
        "div",
        { staticClass: "text-right" },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "ripple",
                  rawName: "v-ripple.400",
                  value: "rgba(255, 255, 255, 0.15)",
                  expression: "'rgba(255, 255, 255, 0.15)'",
                  modifiers: { "400": true }
                }
              ],
              attrs: { variant: "primary", "data-cy": "save-entity" },
              on: { click: _vm.attemptSaveEntity }
            },
            [_vm._v(" Guardar ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }